import React from 'react';
import { faFacebook, faYelp, faInstagram, faYoutube, faXTwitter, faTiktok } from "@fortawesome/free-brands-svg-icons";
import GenericSettings from "./GenericSettings";

const SocialMediaLinks = () => {

  const configuration = [
    {
      title: "Business Social Media Links",
      description: "",
      inputs: [
        {
          type: "input",
          name: "Facebook",
          icon: faFacebook,
          id: "socialMediaLinks.facebook",
        },
        {
          type: "input",
          name: "Instagram",
          icon: faInstagram,
          id: "socialMediaLinks.instagram",
        },
        {
          type: "input",
          name: "X (Twitter)",
          icon: faXTwitter,
          id: "socialMediaLinks.twitter",
        },
        {
          type: "input",
          name: "Youtube",
          icon: faYoutube,
          id: "socialMediaLinks.youtube",
        },
        {
          type: "input",
          name: "TikTok",
          icon: faTiktok,
          id: "socialMediaLinks.tiktok",
        },
        {
          type: "input",
          name: "Yelp",
          icon: faYelp,
          id: "socialMediaLinks.yelp",
        },
        {
          type: "input",
          name: "Vitals",
          custom_icon: 'https://prod-viva-assets.s3.us-west-2.amazonaws.com/favicon-vitals.png',
          id: "socialMediaLinks.vitals",
        },
        {
          type: "input",
          name: "Rate Mds",
          custom_icon: 'https://prod-viva-assets.s3.us-west-2.amazonaws.com/favicon-rate_mds.png',
          id: "socialMediaLinks.rate_mds",
        },
        {
          type: "input",
          name: "Health Grades",
          custom_icon: 'https://prod-viva-assets.s3.us-west-2.amazonaws.com/favicon-health_grades.ico',
          id: "socialMediaLinks.health_grades",
        },
      ],
    },
  ];

  return (
      <GenericSettings configuration={configuration} endpoint={'/settings/business'} method={"put"}/>
  );

};

export default SocialMediaLinks;